import Vue from 'vue'
import Vuex from 'vuex'
import CONFIG from '../common/config'

Vue.use(Vuex)

const lang = localStorage.getItem(CONFIG.LOCALE_KEY_LANG)

export default new Vuex.Store({
  state: {
    apiLang: lang === 'zh' ? 'zh-CN' : 'en-US',
    article: {},
  },
  mutations: {
    changeLang(state, val) {
      state.apiLang = val === 'zh' ? 'zh-CN' : 'en-US'
    },
    saveArticle(state, val) {
      state.article = val
    },
  },
  getters: {
    getApiLang: state => state.apiLang,
    getArticle: state => state.article,
  },
})
